module.exports = (__webpack_require__(8))(588);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/redux/es/index.js from dll-reference vendors
// module id = 712
// module chunks = 0